import React, { useEffect } from 'react';
import { CustomModal, Button, Typography } from 'seagull';
import { useGlobalContext } from 'seagull';
import { useHistory } from 'react-router-dom';
import { routes } from "../../../../constants";
import { useStore } from "../../../../contexts";
import { selectors } from "../../../../store/state-selectors";
import ConnectionToQboIllustration from "./connectionToQboIllustration.svg";
import styles from "./PostConnectionModal.module.scss";
import { IntegrationStatus } from "../../../../types/api/integration.model";
export default function PostConnectionModal() {
  const qboIntegration = useStore(selectors.integration.qboIntegration);
  const {
    showModal,
    hideModal
  } = useGlobalContext();
  const history = useHistory();
  const integrationStatus = qboIntegration === null || qboIntegration === void 0 ? void 0 : qboIntegration.status;
  useEffect(() => {
    if (!integrationStatus) return;
    if (integrationStatus !== IntegrationStatus.Linked) history.replace(routes.integrations);
    showModal({
      content: _ref => {
        let {
          dismissModal
        } = _ref;
        return /*#__PURE__*/React.createElement(ActualPostConnectionModal, {
          dismissModal: dismissModal
        });
      },
      closeOnClickOutside: true,
      closeOnEscapeKey: true
    }).then(() => history.replace(routes.qboSetup));
    return () => {
      hideModal();
    };
  }, [integrationStatus]);
  return null;
}
function ActualPostConnectionModal(props) {
  const {
    dismissModal
  } = props;
  return /*#__PURE__*/React.createElement(CustomModal, {
    "data-testid": "post-connection-modal",
    footer: /*#__PURE__*/React.createElement("div", {
      className: styles.footer
    }, /*#__PURE__*/React.createElement(Button, {
      "data-testid": "post-connection-modal-close-button",
      onClick: dismissModal
    }, "Close")),
    onClose: dismissModal
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.postConnectionWrapper
  }, /*#__PURE__*/React.createElement(ConnectionToQboIllustration, null), /*#__PURE__*/React.createElement(Typography, {
    variant: "h4",
    weight: "normal"
  }, "Connection complete!"), /*#__PURE__*/React.createElement("div", {
    className: styles.textWrapper
  }, /*#__PURE__*/React.createElement(Typography, null, "QuickBooks is now successfully connected."), /*#__PURE__*/React.createElement(Typography, null, "We are matching your contacts with QuickBooks. Once finished, you may manually verify and match."))));
}